/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { NgForm} from "@angular/forms";
import {ViolationDefinition} from "../../model/ViolationDefinition";
import {NgxSpinnerService} from 'ngx-spinner';
import {ViolationDefinitionService} from "../../services/violation-definition.service";
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-violation-definition',
    templateUrl: './violation-definition.component.html',
    styleUrls: ['./violation-definition.component.less'],
    standalone: false
})
export class ViolationDefinitionComponent extends BaseMessageComponent implements OnInit {
  @ViewChild('documentEditForm') documentEditForm: ElementRef;
  public violationDefs: ViolationDefinition[];

  constructor(private spinnerService: NgxSpinnerService,
              private violationDefinitionService: ViolationDefinitionService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getAllDefinitions();
  }

  private getAllDefinitions(){
    this.spinnerService.show();
    this.violationDefinitionService.getSorted().subscribe(value => {
        this.violationDefs = value;
        this.cdr.detectChanges();
      },
      err => {
        this.spinnerService.hide();
        console.log(err);
        alert(err);
      },
      () => {
        //this.loading=false;
        this.spinnerService.hide();
      }
    );
  }

  private getChangedProperties(f:NgForm): string[] {
    let changedProperties = [];

    Object.keys(f.controls).forEach((name) => {
      let currentControl = f.controls[name];

      if (currentControl.dirty)
        changedProperties.push(name);
    });

    return changedProperties;
  }

  private getChangedIndex(f:NgForm): number[] {
    let changedIndexes = [];

    Object.keys(f.controls).forEach((name) => {
      let currentControl = f.controls[name];

      if (currentControl.dirty){
        let UIindex = +name.substr(name.indexOf('__')+2);

        changedIndexes.push(UIindex);
      }

    });

    return changedIndexes;
  }

  addNew(classification: string, type: string, desc: string, points: number){
    this.spinnerService.show();
    var newViolationDef = new ViolationDefinition();
    newViolationDef.classification = classification;
    newViolationDef.type = type;
    newViolationDef.description = desc;
    newViolationDef.points = points;

    this.violationDefinitionService.addNewViolationDefinition(newViolationDef).subscribe(retVal=>{
      this.getAllDefinitions();
    },(error)=>{
      this.spinnerService.hide();
      if (error.status=='409')
        alert("Duplicate Value(s) found.");
      else
        alert(error.message);
    },()=>{
      this.spinnerService.hide();
      this.returnMessage = 'Adding Violation Definition finished';
      setTimeout(() => {
        this.returnMessage = '';
      },2000);
    });
  }

  onSubmit(f: NgForm) {
    // console.log(f.value);  // { first: '', last: '' }
    // console.log(f.valid);  // false

    this.spinnerService.show();
    let count = 0;
    let array = this.getChangedIndex(f);
    var violationDefIds = array.filter(function(elem, index, self) {
      return index == self.indexOf(elem);
    });
    if (violationDefIds!=null && violationDefIds.length>0)
    {
      violationDefIds.forEach(vdi=>{
        var violationDefChanged = this.violationDefs.find(x=>x.violationDefinitionId === vdi);
        this.violationDefinitionService.updateViolationDefinition(violationDefChanged).subscribe(retValue=>{
          //something here?
        },(error)=>{
          this.spinnerService.hide();
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.returnMessage = '';
          this.getAllDefinitions();
          count = 0;
        },()=>{
          count = count + 1;
          if (count>=violationDefIds.length) {
            this.clearNgForm();
            count =0;
            this.spinnerService.hide();
          }
        });
      });
    }
    else{
      this.spinnerService.hide();
      alert("No changes to save.");
    }
  }

  private clearNgForm(){
      this.returnMessage = '';
      this.getAllDefinitions();
      this.returnMessage = 'Updating Violation Definition finished';
      setTimeout(() => {
        this.returnMessage = '';
      }, 2000);
  }

}
